<template>
    <div class="pack-box gift-choice gift-choice__tableau ">
        <div class="pack-title">

            <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux"/>
            <h3>
                Kies je <span class="orange-text"> geschenk</span>
            </h3>
        </div>
        <h6 class="text-uppercase orange-text">Krijg toegang tot een uitgebreide catalogus met geschenken</h6>
        <p>
            Consumeren gaat gepaard met keuzevrijheid. Testaankoop laat je daarom zelf je geschenk kiezen uit een
            uitgebreide catalogus.
        </p>
        <div class="tableau">
            <div class="tableau-title-container">
                <p class="tableau-title">Een paar voorbeelden van cadeau’s </p>
                <p class="product-price tableau-title">Prijs</p>
            </div>
            <div class="product-row" v-for="elem in box_list">
                <p class="product-name" v-html="elem[0]"></p>
                <p class="product-price" v-html="elem[1]"></p>
            </div>
            <p class="asterix" v-if="meta.box_text" v-html="meta.box_text"></p>
        </div>
        <div class="gifts-dropdown">
            <GiftForm :is_dropdown="true" />
            <b-button class="button is-primary next-button" @click="nextStep()" :disabled="!selectedGiftId"
            >
                Vraag je pakket aan
            </b-button>
        </div>
    </div>
</template>

<script>
import image_mixin from "../_commons/fr/mixins/image_mixin.js";
import mixin from "../../components/form/steps/travel_step_mixin";
import GiftForm from "../../components/form/steps/library/nl/giftchoice/GiftForm.vue";
import {sync} from "vuex-pathify";
import store from "../../store/index.js";

export default {
    name: "GiftChoiceDynamic",
    components: {GiftForm},
    mixins: [image_mixin, mixin],
     computed: {
        selectedGiftId: sync('form_data/gift'),
    },
}
</script>
